import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { inputControl?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      surveyViewOuterContainer: {
        height: '809px',
        padding: '0 24px 24px',
        [theme.breakpoints.down('lg')]: {
          height: '1660px'
        }
      },
      surveyViewInnerContainer: {
        background: 'white',
        padding: '30px 64px',
        [theme.breakpoints.down('lg')]: {
          height: props.inputControl ? '1200px' : '1625px',
          padding: '98px 30px 48px 30px'
        }
      },
      surveyViewInputsBox: {
        height: '500px',
        flex: '1 1 0%',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          height: props.inputControl ? '650px' : '1000px'
        }
      },
      surveyViewInputsContainer: {
        padding: '0px 80px',
        height: props.inputControl ? '250px' : '500px',
        [theme.breakpoints.down('lg')]: {
          height: props.inputControl ? '650px' : '100%',
          padding: '0px 0px 0px 0px'
        }
      },
      surveyInputField: {
        [theme.breakpoints.down('lg')]: {
          minWidth: '350px !important',
          fontSize: '30px'
        }
      },
      surveyInputLabel: {
        fontWeight: 600,
        fontSize: '32px',
        margin: '0px',
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px'
        }
      }
    })
  );
